<!--<template>
<div id="ag-grid-demo">
    <vx-card>
        <vs-row>
            <vs-col class="w-1/2">
                <div class="dropdown">
                    <a class="flex items-center" href.prevent>
                        <vs-button type="border" @click="filterShow^=true">Filter</vs-button>
                    </a>
                    <div class="dropdown-content" v-if="filterShow">
                        <div class="vx-row">&nbsp;</div>

                        <vs-row class="mb-4">
                            <vs-col class="sm:w-1/6 w-full topPad">
                                <span class="inputStyles">Doctor</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/2 w-full">
                                <vs-select v-model="filter.doctorId">
                                    <vs-select-item :value="item.id" :text="item.name" v-for="(item,index) in doctorList" v-bind:key="index" />
                                </vs-select>
                            </vs-col>
                        </vs-row>

                        <vs-row class=" mb-4">
                            <vs-col class=" sm:w-1/6 w-full topPad">
                                <span class="inputStyles">Status</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/2 w-full">
                                <vs-select v-model="filter.status">
                                    <vs-select-item :value="item.id" :text="item.name" v-for="(item,index) in statusList" v-bind:key="index" />
                                </vs-select>
                            </vs-col>
                        </vs-row>

                        <vs-row class=" mb-4">
                            <vs-col class=" sm:w-1/6 w-full topPad">
                                <span class="inputStyles">From</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/3 w-full">
                                <flat-pickr v-model="filter.dateFrom" placeholder="From Date" />
                            </vs-col>
                            <vs-col class=" sm:w-1/12 w-full topPad">
                                <span class="inputStyles">To</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/4 w-full">
                                <flat-pickr v-model="filter.dateTo" placeholder="To Date" />
                            </vs-col>
                        </vs-row>
                        <vs-col class="w-1/2">
                            <div align="left" style="margin-right:8%;">
                                <vs-button color="success" type="border" @click="clear">Clear</vs-button>
                            </div>
                        </vs-col>
                        <vs-col class="w-1/2">
                            <div align="right" style="margin-right:8%;">
                                <vs-button color="success" type="gradient" @click="onGridReady">Apply</vs-button>
                            </div>
                        </vs-col>
                    </div>
                </div>
            </vs-col>
            <vs-col class="w-1/2">
                <vs-row class="mb-4 1/6" style="margin-left:80%;">
                    <vs-col class=" sm:w-1/12 w-full">

                        <img src="@/assets/images/logo/pdf.jpg" style="cursor:pointer" @click="getPdfReport" width="35px" height="35px;" />

                    </vs-col>
                    <vs-col class=" sm:w-1/6 w-full">
                        <img src="@/assets/images/logo/xcl.png" style="cursor:pointer" @click="getExcelReport" width="35px" height="35px;" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>

        <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination style="margin-top:-60px;" :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
</div>
</template>-->
<template>
  <div id="token-report-page">
    <vx-card class="cHeight">

      <!-- FROM DATE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">From Date</span>
        </vs-col>

        <vs-col class="w-1/4">
          <flat-pickr v-model="dateFrom" :config="dateConfig" class="w-full inputField" />
        </vs-col>
      </vs-row>

      <!-- TO DATE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">To Date</span>
        </vs-col>

        <vs-col class="w-1/4">
          <flat-pickr v-model="dateTo" :config="dateConfig" class="w-full inputField" />
        </vs-col>
      </vs-row>

      <!-- DOCTOR -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Doctor</span>
        </vs-col>

        <vs-col class="w-1/4">
          <vs-select v-model="doctorId" class="w-full inputField">
            <vs-select-item
              v-for="doc in doctorList"
              :key="doc.id"
              :value="doc.id"
              :text="doc.name"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- STATUS -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Status</span>
        </vs-col>

        <vs-col class="w-1/4">
          <vs-select v-model="status" class="w-full inputField">
            <vs-select-item
              v-for="item in statusList"
              :key="item.id"
              :value="item.id"
              :text="item.name"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- EXPORT TYPE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Export Type</span>
        </vs-col>

        <vs-col class="w-2/3">
          <vs-radio v-model="reportType" vs-value="PDF">PDF</vs-radio>
          <vs-radio v-model="reportType" vs-value="EXCEL" style="margin-left:20px">Excel</vs-radio>
        </vs-col>
      </vs-row>

      <!-- BUTTONS -->
      <vs-row style="margin-top:30px;">
        <vs-col class="w-full sm:w-1/6"></vs-col>

        <vs-col class="w-full sm:w-1/3">
          <vs-button @click="generateReport" style="margin-right:20px;">
            Preview
          </vs-button>

          <vs-button @click="clearForm">
            Clear
          </vs-button>
        </vs-col>
      </vs-row>

    </vx-card>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {

  components: { flatPickr },

  data() {
    return {
      dateFrom: null,
      dateTo: null,

      doctorId: null,
      doctorList: [],

      status: null,
      statusList: [
        { id: null, name: "ALL" },
        { id: "OP", name: "OP" },
        { id: "Booked", name: "Booked" }
      ],

      reportType: 'PDF',

      dateConfig: {
        dateFormat: "d-m-Y"
      }
    }
  },

  mounted() {
    this.getDoctorList();
  },

  methods: {

    formatDate(date) {
      if (!date) return null;
      return date.split('-').reverse().join('-');
    },

    clearForm() {
      this.dateFrom = null;
      this.dateTo = null;
      this.doctorId = null;
      this.status = null;
      this.reportType = 'PDF';
    },

    async getDoctorList() {
      var request = {
        companyId: this.$session.get('companyId')
      };

      const response = await this.$http.post(
        "getdoctorlist",
        JSON.stringify(request),
        { headers: { "Content-Type": "application/json" } }
      );

      this.doctorList = [];

      
      this.doctorList.push({
        id: null,
        name: "ALL"
      });

      response.data.data.forEach((value) => {
        this.doctorList.push(value);
      });
    },

    generateReport() {
      if (this.reportType === 'PDF') {
        this.getPdfReport();
      } else {
        this.getExcelReport();
      }
    },

    getPdfReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          dateFrom: this.formatDate(this.dateFrom),
          dateTo: this.formatDate(this.dateTo),
          doctorId: this.doctorId,
          status: this.status
        }
      };

      this.$http.post("gettokenreportpdf", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    },

    getExcelReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          dateFrom: this.formatDate(this.dateFrom),
          dateTo: this.formatDate(this.dateTo),
          doctorId: this.doctorId,
          status: this.status
        }
      };

      this.$http.post("gettokenreportxls", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    }
  }
}
</script>
<style scoped>
.cHeight {
  min-height: 80vh;   
}
.inputField {
  height: 36px;
  width: 100%;
}
.label {
  font-size: 13.2px;
  font-weight: 600;
  padding-top: 6px;
  display: inline-block;
}
</style>
<!--<script>
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            filterShow: false,
            filter: {
                dateFrom: null,
                dateTo: null,
                status: null,
                doctorId: null
            },
            statusList: [{
                id: null,
                name: "Select"
            }, {
                id: "OP",
                name: "OP"
            }, {
                id: "Booked",
                name: "Booked"
            }],
            doctorList: [{
                id: null,
                name: "Select"
            }],
            gridOptions: {
                rowModelType: 'infinite',
                rowStyle: {
                    'text-align': 'center'
                },
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: false,
                resizable: true,
                suppressMenu: true,
            },

            columnDefs: [{
                    headerName: 'Doctor Name',
                    field: 'doctor',
                    width: 254,
                    cellStyle: {
                        'text-align': 'left'
                    },
                },
                {
                    headerName: 'Appointment Date',
                    field: 'appointmentDate',
                    width: 157,
                    cellStyle: {
                        'text-align': 'center'
                    },

                },
                {
                    headerName: 'Appointment Time',
                    field: 'appointmentTime',
                    width: 162,
                    cellStyle: {
                        'text-align': 'center'
                    },
                },
                {
                    headerName: 'Token No',
                    field: 'tokenNo',
                    width: 126,
                    cellStyle: {
                        'text-align': 'center'
                    },
                },
                {
                    headerName: 'Phone No',
                    field: 'phoneNo',
                    width: 147,
                    cellStyle: {
                        'text-align': 'center'
                    },
                },
                {
                    headerName: 'Status',
                    field: 'status',
                    width: 149,
                    cellStyle: {
                        'text-align': 'center'
                    },
                }

            ],
            contacts: [{}],
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady()
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
        this.getDoctorList();
    },
    methods: {
        clear() {
            this.filter.dateFrom = null;
            this.filter.dateTo = null;
            this.filter.status = null;
            this.filter.doctorId = null;
        },
        getDoctorList() {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "getdoctorlist",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.doctorList.push(value);
                    })
                });
        },

        onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            this.filterShow = false;
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.filter
            }

            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "gettokenreports",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data.records, response.data.data.recordsTotal);
                            this.gridApi.hideOverlay();

                        });

                }
            }
            this.gridApi.setDatasource(datasource);
        },
        getExcelReport() {
            var request = {
                companyId: this.$session.get('companyId'),
                filter: this.filter
            }
            this.$http.post(
                    "gettokenreportxls",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    window.open(response.data.data.filePath);
                });
        },
        getPdfReport() {
            var request = {
                companyId: this.$session.get('companyId'),
                filter: this.filter
            }
            this.$http.post(
                    "gettokenreportpdf",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    window.open(response.data.data.filePath);
                });
        }
    }

}
</script>

<style scoped>
.dropdown-content {

    position: absolute;
    background-color: #f9f9f9;
    min-width: 690%;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 1;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.ag-header-cell-label {
    justify-content: center;
}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
</style>-->
